/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Import all the third party stuff
import React from "react";
import ReactDOM from "react-dom/client"; // updated import for React 18 root API
import "@aws-amplify/ui-react/styles.css";

// Import root app
import App from "containers/App";
import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";

import "assets/scss/material-kit-pro-react.scss?v=1.3.0";
import RootStore from "./mobX/RootStore";
import { GraphqlApi } from "./graphql/api";
import { RootStoreContext } from "./mobX/RootStore";
import { BrowserRouter } from "react-router-dom";
import { amplifyconfiguration } from "amplifyconfiguration";

const MOUNT_NODE = document.getElementById("app");

Amplify.configure(amplifyconfiguration(), {
  API: {
    GraphQL: {
      headers: async () => ({
        Authorization: (await fetchAuthSession()).tokens?.idToken?.toString(),
      }),
    },
  },
});

const tenantPath = new URL(location.href).pathname.split("/")[1];
const transportLayer = new GraphqlApi();
const rootStore = new RootStore(transportLayer, tenantPath);

// React 18 way: create root and render
const root = ReactDOM.createRoot(MOUNT_NODE);

root.render(
  <BrowserRouter>
    <RootStoreContext.Provider value={rootStore}>
      <App />
    </RootStoreContext.Provider>
  </BrowserRouter>
);
